import React, { useEffect, useMemo, useRef, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { ArrowRight, Clock3, Search, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from './ui';
import { QUICK_ROUTE_IDS, routeRegistry, searchRoutes } from '../config/routeRegistry';

export default function CommandPalette({ open, onOpenChange, recentIds = [] }) {
  const [query, setQuery] = useState('');
  const [active, setActive] = useState(0);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const results = useMemo(() => query ? searchRoutes(query) : [
    ...recentIds.map((id) => routeRegistry.find((route) => route.id === id)).filter(Boolean),
    ...QUICK_ROUTE_IDS.map((id) => routeRegistry.find((route) => route.id === id)).filter(Boolean),
  ].filter((route, index, all) => all.findIndex((item) => item.id === route.id) === index), [query, recentIds]);

  useEffect(() => { if (open) { setQuery(''); setActive(0); requestAnimationFrame(() => inputRef.current?.focus()); } }, [open]);
  useEffect(() => { setActive(0); }, [query]);
  const go = (route) => { if (!route) return; navigate(route.path); onOpenChange(false); };
  const handleKey = (event) => {
    if (event.key === 'ArrowDown') { event.preventDefault(); setActive((v) => Math.min(v + 1, results.length - 1)); }
    if (event.key === 'ArrowUp') { event.preventDefault(); setActive((v) => Math.max(v - 1, 0)); }
    if (event.key === 'Enter') { event.preventDefault(); go(results[active]); }
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="cc-dialog-overlay cc-command-overlay" />
        <Dialog.Content className="cc-command" onKeyDown={handleKey}>
          <Dialog.Title className="cc-visually-hidden">Przejdź do modułu</Dialog.Title>
          <Dialog.Description className="cc-visually-hidden">Wyszukaj moduł panelu i otwórz go klawiszem Enter.</Dialog.Description>
          <div className="cc-command__search"><Search size={19} /><input ref={inputRef} value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Wyszukaj moduł, funkcję lub działanie…" aria-label="Wyszukaj moduł" /><Dialog.Close asChild><IconButton label="Zamknij paletę" icon={X} size="sm" /></Dialog.Close></div>
          <div className="cc-command__caption">{query ? `${results.length} wyników` : recentIds.length ? <><Clock3 size={13} /> Ostatnie i najważniejsze</> : 'Najważniejsze moduły'}</div>
          <div className="cc-command__results" role="listbox" aria-label="Moduły">
            {results.map((route, index) => { const Icon = route.icon; return <button type="button" role="option" aria-selected={index === active} className={index === active ? 'is-active' : ''} key={route.id} onMouseEnter={() => setActive(index)} onClick={() => go(route)}><span className="cc-command__icon"><Icon size={18} /></span><span><strong>{route.label}</strong><small>{route.description}</small></span><ArrowRight size={16} /></button>; })}
            {!results.length && <div className="cc-command__empty">Nie znaleźliśmy modułu. Spróbuj użyć prostszego hasła.</div>}
          </div>
          <footer><span><kbd>↑</kbd><kbd>↓</kbd> wybór</span><span><kbd>Enter</kbd> otwórz</span><span><kbd>Esc</kbd> zamknij</span></footer>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
